import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, FileTextIcon, ImageIcon, PrinterIcon, SparklesIcon } from 'lucide-react';
export function HeroSection() {
  const badges = [{
    icon: FileTextIcon,
    label: '+1.000 páginas'
  }, {
    icon: ImageIcon,
    label: 'Alta resolución'
  }, {
    icon: DownloadIcon,
    label: 'Descarga inmediata'
  }, {
    icon: PrinterIcon,
    label: 'Impresión de calidad'
  }];
  return <section className="relative py-12 md:py-20 px-4 bg-[#FFFAF7] overflow-hidden" data-id="element-46" data-mp="2wk8tb14rdqfl">
      {/* Soft pastel background accents */}
      <div className="pointer-events-none absolute -top-24 -left-24 w-72 h-72 rounded-full bg-[#FF6B8A]/10 blur-3xl" data-id="element-47" data-mp="30n58ehv3b4es" />
      <div className="pointer-events-none absolute -bottom-24 -right-24 w-80 h-80 rounded-full bg-[#9B8FE8]/10 blur-3xl" data-id="element-48" data-mp="2rsqp847fv9qe" />

      <div className="relative max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10 md:gap-16" data-id="element-49" data-mp="3fhjrsjikgftz">
        {/* Mobile: Images on top / Desktop: Right column */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6
      }} className="w-full md:w-1/2 order-1 md:order-2 relative h-[400px] sm:h-[520px] md:h-[600px] flex items-center justify-center" data-id="element-50" data-mp="2ff8uiueo68vy">
          <div className="absolute z-40 -top-2 right-2 md:right-6 bg-[#FFD166] text-[#2D2D3F] font-black px-4 py-2 rounded-full shadow-lg transform rotate-6 text-sm md:text-base border-2 border-white" data-id="element-51" data-mp="2ke3azpp5zlcw">
            ⭐ Más elegido
          </div>

          <img src="https://cdn.magicpatterns.com/uploads/ovxazyqe6TbNyon72GLS97/MEGA_PACK.png" alt="Mega Pack Disney Mockup" width="800" height="800" fetchPriority="high" decoding="async" loading="eager" className="w-full max-w-[620px] object-contain drop-shadow-[0_25px_45px_rgba(0,0,0,0.18)]" data-id="element-52" data-mp="2u451eo4zpfuz" />
        </motion.div>

        {/* Mobile: Text below / Desktop: Left column */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="w-full md:w-1/2 order-2 md:order-1 flex flex-col space-y-8" data-id="element-53" data-mp="18s4wor9dmysc">
          {/* Premium eyebrow badge */}
          

          <div className="space-y-5" data-id="element-54" data-mp="3ipxuee0q2toy">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-[#2D2D3F] leading-[1.05] tracking-tight" data-id="element-55" data-mp="3mt48g7u2tp5z">
              Mega Pack <br className="hidden sm:block" data-id="element-56" data-mp="3rr5mufgk50b4" />
              <span className="relative inline-block" data-id="element-57" data-mp="3rqcp23zktl54">
                <span className="relative z-10" data-id="element-58" data-mp="kl2fel0cqn2">Disney</span>
                <span className="absolute inset-x-0 bottom-1 h-3 sm:h-4 bg-[#FFD166]/50 -z-0 rounded-sm" data-id="element-59" data-mp="5curyti7noot" />
              </span>{' '}
              <span className="text-[#FF6B8A]" data-id="element-60" data-mp="aanwzj7s2cni">Coloring</span>
            </h1>

            <p className="text-base sm:text-lg text-[#6B7280] font-medium max-w-md leading-relaxed" data-id="element-61" data-mp="edst9419li3p">
              10 libros de la colección en tendencia{' '}
              <span className="inline-block bg-[#9B8FE8]/15 text-[#5B4FB8] font-semibold px-2 py-0.5 rounded-md" data-id="element-62" data-mp="ja15o9o2ux76">
                Colorea y Descubre el Misterio
              </span>
              , con más de 100 páginas para colorear en cada uno.
              <br data-id="element-63" data-mp="1usyg5bt9w2p7" />
              <span className="inline-block mt-2 text-[#FF6B8A] font-bold" data-id="element-64" data-mp="1uu9si00sairx">
                🎁 NUEVO REGALO: Winx Club Coloring Book con 50 diseños para colorear.
              </span>
            </p>
          </div>

          {/* Feature badges */}
          <ul className="grid grid-cols-2 gap-2.5 sm:gap-3 max-w-md" data-id="element-65" data-mp="2ijax1c6hx9rx">
            {badges.map(({
            icon: Icon,
            label
          }, index) => <li key={index} className="flex items-center gap-2 bg-white border border-gray-100 rounded-xl px-3 py-2.5 shadow-sm" data-id="element-66" data-mp="2dr17hx9ambq6" data-mpi={index}>
                <div className="bg-[#FFD166]/20 p-1.5 rounded-lg shrink-0" data-id="element-67" data-mp="28rok9beif2n2">
                  <Icon className="w-4 h-4 text-[#FF6B8A]" data-id="element-68" data-mp="36a7ujjxjo4jn" />
                </div>
                <span className="text-xs sm:text-sm font-semibold text-[#2D2D3F] leading-tight" data-id="element-69" data-mp="31hesj3tgnab9">
                  {label}
                </span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}